import { normaliseEmailArray } from "src/utils";
import { CreateVendorFormData, PostVendorRequestBody } from "src/types";
import { VendorFileType } from "src/enums/vendorFileType";
import { CollectionType } from "src/enums/collectionType";
export class CreateVendorMapper {
  public static initCreateVendorFormData(): CreateVendorFormData {
    return {
      vendorName: "",
      emails: [""],
      location: "",
      portalOrderVendor: false,
      collectionOrderVendor: false,
      collectionType: CollectionType.BRAND_SHIPS, // Default to "Brand Ships" when collectionOrderVendor is false
      isProForma: false,
      emailGreeting: "",
      portalAccess: false,
      fileType: VendorFileType.PDF,
      invoiceName: "",
      paymentTerms: "",
      incoTerms: "" as const,
      countryOfExport: [],
      shipmentDetails: {
        opsPOC: "",
        notes: "",
        ein: "",
        collection: "",
        ciRequired: false,
        bolRequired: false,
        addresses: [],
        contactPerson: "",
        contactInfo: "",
        email: ""
      },
      isDirectToAA: false
    };
  }

  public static createVendorRequestBodyFromFormData(formData: CreateVendorFormData): PostVendorRequestBody {
    const normalisedEmails = normaliseEmailArray(formData.emails);
    const normalisedPortalOrderVendor = formData.portalOrderVendor || undefined;
    const normalisedCollectionOrderVendor = formData.collectionOrderVendor || undefined;
    const normalisedCollectionType = formData.collectionType || undefined;
    const normalisedIsProForma = formData.isProForma || undefined;
    const normalisedEmailGreeting = formData.emailGreeting || undefined;
    const normalisedPortalAccess = formData.portalAccess || undefined;
    const normalisedFileType = formData.fileType || undefined;

    const shipmentDetails = formData.shipmentDetails || {};
    const hasAnyValue =
      shipmentDetails.opsPOC?.trim() ||
      shipmentDetails.notes?.trim() ||
      shipmentDetails.ein?.trim() ||
      shipmentDetails.collection?.trim() ||
      shipmentDetails.contactPerson?.trim() ||
      shipmentDetails.contactInfo?.trim() ||
      shipmentDetails.email?.trim() ||
      (shipmentDetails.addresses && shipmentDetails.addresses.length > 0);

    const normalisedShipmentDetails = hasAnyValue ? shipmentDetails : undefined;

    const normalisedInvoiceName = formData.invoiceName?.trim() || undefined;
    const normalisedPaymentTerms = formData.paymentTerms?.trim() || undefined;
    const normalisedIncoTerms = formData.incoTerms || undefined;
    const normalisedCountryOfExport =
      formData.countryOfExport && formData.countryOfExport.length > 0 ? formData.countryOfExport : undefined;

    return {
      name: formData.vendorName,
      emails: normalisedEmails,
      location: formData.location,
      portalOrderVendor: normalisedPortalOrderVendor,
      collectionOrderVendor: normalisedCollectionOrderVendor,
      collectionType: normalisedCollectionType,
      isProForma: normalisedIsProForma,
      emailGreeting: normalisedEmailGreeting,
      portalAccess: normalisedPortalAccess,
      fileType: normalisedFileType,
      invoiceName: normalisedInvoiceName,
      paymentTerms: normalisedPaymentTerms,
      incoTerms: normalisedIncoTerms,
      countryOfExport: normalisedCountryOfExport,
      shipmentDetails: normalisedShipmentDetails,
      isDirectToAA: formData.isDirectToAA || undefined
    };
  }
}
